import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import AvatarImg from "../../assets/svg/Handovers/ClientProfile.svg";
import Avatar from "react-avatar-edit";
import * as api from "../../api";
import "./user-info.css";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

const UserInfo = () => {
  const navigate = useNavigate();
  const accessToken = useSelector((state) => state.auth.token) || "";
  const [greeting, setGreeting] = useState("");
  const [avatarPic, setAvatarPic] = useState(null);
  const {
    _id: userId,
    firstName = "",
    lastName = "",
    picture: userImg = "",
  } = useSelector((state) => state.user);
  const [preview, setPreview] = useState(userImg);
  const [picture, setPicture] = useState({
    picture: "",
  });
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (userImg) {
      setPreview(userImg);
    }
  }, [userImg]);

  const generateGreetings = (currentHour) => {
    if (currentHour >= 0 && currentHour < 12) {
      setGreeting("Good Morning");
    } else if (currentHour >= 12 && currentHour < 17) {
      setGreeting("Good Afternoon");
    } else if (currentHour >= 17) {
      setGreeting("Good Evening");
    }
  };

  useEffect(() => {
    generateGreetings(moment().format("HH"));
  }, []);

  const getUserPhoto = async () => {
    setLoader(true);
    try {
      const data = await api.getUserPhoto(userId, accessToken);
      const img = data.data.data;
      setPreview(img);
      setLoader(false);
    } catch (err) {
      setLoader(false);
      invalidToken(err);
    }
  };

  useEffect(() => {
    getUserPhoto();
  }, []);

  const onClose = () => {
    setPreview("");
    getUserPhoto();
  };

  const onCrop = (view) => {
    setPreview(view);
  };

  const onBeforeFileLoad = (elem) => {
    if (elem.target.files[0].size > 3000000) {
      Swal.fire({
        title: "Error!",
        html: "File is too big",
        icon: "error",
        confirmButtonColor: "#325ba6",
      });
      elem.target.value = "";
    }
  };

  useEffect(() => {
    setPicture({ ...picture, picture: preview });
  }, [preview]);

  const cancelUpdatePhoto = () => {
    if (preview === "" || preview === null) {
      setPreview("");
      setShow(false);
    } else {
      setShow(false);
      getUserPhoto();
    }
  };

  const exportImage = () => {
    const img = new Image();
    img.src = preview;

    return new Promise((resolve) => {
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // Set the desired export resolution
        const exportQuality = 0.5; // Adjust quality
        const width = img.width * exportQuality;
        const height = img.height * exportQuality;

        canvas.width = width;
        canvas.height = height;

        // Draw the image onto the canvas
        ctx.drawImage(img, 0, 0, width, height);

        // Export the image as a high-quality PNG
        const highQualityImage = canvas.toDataURL("image/png", 1.0);

        // Resolve the promise with the exported image
        resolve(highQualityImage);
      };
    });
  };

  const updatePhoto = async () => {
    setLoader(true);
    try {
      const exportedPicture = await exportImage();
      const imageUpload = {
        picture: exportedPicture,
      };
      await api.updateUserPhoto(imageUpload, userId, accessToken);
      Swal.fire({
        title: "Success!",
        icon: "success",
        html: "Photo updated successfully!",
        confirmButtonColor: "#325ba6",
      });
      setLoader(false);
      setShow(false);
    } catch (error) {
      Swal.fire({
        title: "Error!",
        html: "Error Updating Photo",
        icon: "error",
        confirmButtonColor: "#325ba6",
      });
      setAvatarPic(null);
      setPreview("");
      getUserPhoto();
      setLoader(false);
      setShow(false);
      invalidToken(error);
    }
  };

  const invalidToken = (error) => {
    if (
      error?.response?.status === 401 &&
      error?.response?.data?.errors?.length > 0 &&
      error?.response?.data?.errors[0]?.message === "Invalid Token"
    ) {
      handleExpiration();
    }
  };

  const handleExpiration = () => {
    localStorage.removeItem("auth0-token-storage");
    localStorage.removeItem("user-claims");
    navigate("/login", { replace: true });
  };

  const capitalize = (name = "") =>
    name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");

  const accountName = ["demo", "hr"].includes((firstName || "").toLowerCase())
    ? `${capitalize(firstName)} ${capitalize(lastName)}`
    : capitalize(firstName);

  return (
    <div className="text-center pb-5 mt-5">
      <div className="rounded-circle mx-auto avatar d-flex justify-content-center">
        <img
          src={!loader ? preview || userImg || AvatarImg : AvatarImg}
          alt=""
          className="avatarImg"
        />

        <div className="editAvatar align-self-center"></div>
      </div>
      {/* <div
        className="editAvatar d-flex align-self-center align-items-center justify-content-center orange-1"
        style={{ cursor: "pointer" }}
        onClick={() => setShow(true)}
      >
        <FontAwesomeIcon icon={["fas", "edit"]} style={{ fontSize: "15px" }} />
        <p className="ml-1 orange-1">Edit</p>
      </div> */}
      <div
        className="editAvatar d-flex align-self-center align-items-center justify-content-center orange-1"
        style={{ cursor: "pointer" }}
        onClick={() => navigate("/profile/edit")}
      >
        <FontAwesomeIcon icon={["fas", "edit"]} style={{ fontSize: "15px" }} />
        <p className="ml-1 orange-1">Edit</p>
      </div>

      <p className="pt-3">
        {greeting}, {accountName}!
      </p>
      <Modal size="md" show={show} onHide={cancelUpdatePhoto}>
        <Modal.Header closeButton>
          <Modal.Title className="orange-1">Choose a Picture</Modal.Title>
        </Modal.Header>
        <Modal.Body className="m-auto">
          <Avatar
            src={avatarPic}
            width={400}
            height={300}
            imageWidth={400}
            imageHeight={300}
            onCrop={onCrop}
            onClose={onClose}
            onBeforeFileLoad={onBeforeFileLoad}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelUpdatePhoto}>
            Cancel
          </Button>
          <Button variant="primary" onClick={updatePhoto}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UserInfo;
